import { Colors } from "@batmaid/design-tokens";

type Color = keyof Colors;

const defaultColor: Color = "blue500";

export { Color, defaultColor };
